export interface SaveFingerprintInput {
  input: string;
}

export interface SaveFingerprintOutput {
  inserted: boolean;
}

export default {
  saveFingerprint:
    'mutation ($input: String) {\n saveFingerprint(input: $input) {\n inserted\n }\n}\n'
};
